import { r as m, m as P, a as S } from "./resolveComponentProps-DEADesT4.mjs";
import { u as c } from "./useForkRef-C_4o__cU.mjs";
function x(e) {
  var t;
  const {
    elementType: s,
    externalSlotProps: p,
    ownerState: r,
    skipResolvingSlotProps: n = !1,
    ...a
  } = e, o = n ? {} : m(p, r), {
    props: l,
    internalRef: f
  } = P({
    ...a,
    externalSlotProps: o
  }), i = c(f, o == null ? void 0 : o.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return S(s, {
    ...l,
    ref: i
  }, r);
}
export {
  x as u
};
//# sourceMappingURL=useSlotProps-DmbFUW3M.mjs.map
